window.addEventListener('load', function(){
  var find = null;
  var cart_present = false;
  var count_for_reccurssion = 0;
  // setting interval to check that slide cart is loaded or not
  var present = function(){
    let cart_number = document.querySelector('.hs-count-products-cart');
    if(cart_number){
      //when slide cart loaded call function to add Listeners and clear Interval 
      cart_present = true;
      add_free_shipping();
      clearInterval(find);
    } else {
      cart_present = false;
    }
  };
  find = setInterval(present, 1000);
});


function add_free_shipping(){
  //calling the below two function for the already added products in the cart when page loaded
  free_shipping();
  remove_items_fromCart_listener();
  //selecting the add to cart button and adding listener
  let inputs = document.querySelector('.button--full-width.hs-event-static');
  if(inputs){
    inputs.addEventListener('click', function(){ 
      // when add to cart button pressed we will get the number of items present in cart for that we use the 
      // remove product button from the cart
      let items = document.querySelector(".hs-count-products-cart")
      if(items === null){
        let count = 0;
        var wait_for_cart_header = setInterval(() => {
          if(document.querySelector(".hs-count-products-cart") !== null){
            clearInterval(wait_for_cart_header);
            //when UI loaded it will check the free_shipping condition
            free_shipping();
            // after the item added we have to again register the Listeners
            remove_items_fromCart_listener();
            setTimeout(function(){add_variants_to_upsell();},2000);
          }else if(count > 15){
            setTimeout(function(){add_variants_to_upsell();},2000);
            clearInterval(wait_for_cart_header);
          }
          count ++;
        },100);
      }else{
        items = items.textContent.trim().replace("(","").replace(")","");
        var added_item = setInterval(() => {
          //after the some time it will check that weather item UI is loaded in the cart or not
          if (items < document.querySelector(".hs-count-products-cart").textContent.trim().replace("(","").replace(")","")){
            clearInterval(added_item);
            //when UI loaded it will check the free_shipping condition
            free_shipping();
            // after the item added we have to again register the Listeners
            remove_items_fromCart_listener();
            if (items < '2') {
              let a = 0;
              var until_find_upsell = setInterval(() =>{
                let x = document.querySelector('.hs-products-stacked.hs-manual-products');
                if ( (x && x.children.length > 1) || a > 3 ){
                  add_variants_to_upsell();
                  clearInterval(until_find_upsell);
                }
                a++;
              },500);
            }
          }
        },100);              
      }

    });
  }
}

function remove_items_fromCart_listener() {
  // get all the remove products button from the cart and register listener and whenever product is deleted we have to again 
  // check the free_shipping condition
  clear_all_btn_listener();
  let remove = document.querySelectorAll('.hs-remove-item.hs-event-static');
  for(let x = 0; x < remove.length; x++){
    remove[x].addEventListener('click', function(){ 
      // onclick the remove button we have to wait until the product is removed from the cart
      var deleted_item = setInterval(() => {
        if (remove.length > document.querySelectorAll('.hs-remove-item.hs-event-static').length){
          // when product removed check free shipping condition and register listeners
          free_shipping();
          remove_items_fromCart_listener();
          clearInterval(deleted_item);
        }
      },200);
    });
  }

  // coupan added from the cart
  // let cart = document.querySelectorAll('.hs-apply-discount.hs-event-static')[0].addEvenetListener('click', ()=>{
  //   var coupan_code_added = setInterval(() => {
  //         if (document.querySelector('.hs-success-code-discount').children.length > 0){
  //           free_shipping();
  //           remove_items_fromCart_listener();
  //           clearInterval(coupan_code_added);
  //         }
  //       },200);
  // });
  
  // registering listener on pressing the minus button
  let minus_btns = document.querySelectorAll(".hs-dec.hs-qtybutton.hs-event-static");
  for(let y=0; y < minus_btns.length; y++){
    minus_btns[y].addEventListener('click', function(){
      // if quantity is 1 and when pressing minus button performing same operation as above on removing product
      if(minus_btns[y].nextElementSibling.value === '0'){
        var delete_item_fromCart = setInterval(() => {
          if (remove.length > document.querySelectorAll('.hs-remove-item.hs-event-static').length){
            free_shipping();
            remove_items_fromCart_listener();
            clearInterval(delete_item_fromCart);
          }
        },200);
      } else {
        // if quantity is greater than 1 and on pressing the minus button
        let products_count = document.querySelector(".hs-count-products-cart").textContent.trim().replace("(","").replace(")","");
        // wait until the product quantity is changed
        var item_removed = setInterval(() => {
          if (document.querySelector(".hs-count-products-cart").textContent.trim().replace("(","").replace(")","") < products_count){
            // when product quantity changed check free_shipping condition and register Listeners again
            clearInterval(item_removed);
            free_shipping();
            remove_items_fromCart_listener();
          }
        },200);
      }
    });
  }

  // On pressing plus button
  let plus_btns = document.querySelectorAll('.hs-inc.hs-qtybutton.hs-event-static');
  for(let z = 0; z < plus_btns.length; z++){
    plus_btns[z].addEventListener('click',function(){
      // On click get total product count
      let products_count = document.querySelector(".hs-count-products-cart").textContent.trim().replace("(","").replace(")","");
      var item_added = setInterval(() => {
        // checking until the total product count changes
        if (document.querySelector(".hs-count-products-cart").textContent.trim().replace("(","").replace(")","") > products_count){
          clearInterval(item_added);
          remove_items_fromCart_listener();
          free_shipping();
        }
      },100);
    });
  }

  // On adding product from the suggested products
  let add_btn_from_bottom = document.querySelectorAll('.hs-upsell-add-to-cart.btn.hs-event-static');
  let cart_items_list_count = document.querySelector(".hs-count-products-cart");
  // if cart header in which cart total products are showing is not loaded
  if(cart_items_list_count === null){
    let count = 0;
    // wait until the cart total products will be visible 
    var wait_for_cart_header_visible = setInterval(() => {
      // when cart header loaded clearInterval
      if(document.querySelector(".hs-count-products-cart") !== null){
        clearInterval(wait_for_cart_header_visible);
        cart_items_list_count = document.querySelector(".hs-count-products-cart").textContent.trim().replace("(","").replace(")","");
        upsell_some_checks(cart_items_list_count,add_btn_from_bottom);
      }
        // for safety added the count to wait around 800 miliseconds for the cart header otherwise clearInterval
      else if(count > 4){
        cart_items_list_count = '0';
        clearInterval(wait_for_cart_header_visible);
        upsell_some_checks(cart_items_list_count,add_btn_from_bottom);
      }
      count ++;
    },200);
  }else if (cart_items_list_count !== null){
    // if cart header is loaded then get the count of items in the cart
    cart_items_list_count = document.querySelector(".hs-count-products-cart").textContent.trim().replace("(","").replace(")","");
    let count = 0;
    let ss = setInterval(()=> {
      let x = document.querySelector(".hs-count-products-cart").textContent.trim().replace("(","").replace(")","");
      if (cart_items_list_count != x || count > 2) {
        clearInterval(ss);
        upsell_some_checks(cart_items_list_count,add_btn_from_bottom);
      }
      count++;
    },200);
  } 
}

function upsell_some_checks(cart_items_list_count,add_btn_from_bottom){
  add_variants_to_upsell();
  // If no item is present in cart while items not deleted by clicking clear all
  if (cart_items_list_count == '0'){
    // if suggested products are not loaded wait until they are loaded
    if( add_btn_from_bottom.length <= 1 ){
      var search_items = setInterval(() => {
        if(document.querySelectorAll('.hs-upsell-add-to-cart.btn.hs-event-static').length > 0){
          clearInterval(search_items);
          // On getting products attaching listeners to them
          attach_btn_to_listener();
          add_variants_to_upsell();
        }
      } , 300);
    }else{
      // if suggested products loaded then attach listeners
      attach_btn_to_listener();
      add_variants_to_upsell();
    }
  } else {
    // if cart is not empty
    search_btns_of_upsell();
  }
}

function search_btns_of_upsell(){
  let counts = 0;
    let length_of_btns = document.querySelectorAll('.hs-upsell-add-to-cart.btn.hs-event-static').length;
    var search_item = setInterval(() => {
      // if no product in suggestions product div visibility is none and it is executed for more than 10 times OR if there is a change in suggested products
      if(document.querySelector('.hs-container-stacked.hs-recommend-products') != null && counts > 3 && document.querySelector('.hs-container-stacked.hs-recommend-products').style.display!= 'none' || document.querySelectorAll('.hs-upsell-add-to-cart.btn.hs-event-static').length != length_of_btns ) {
        clearInterval(search_item);
        attach_btn_to_listener();
        add_variants_to_upsell();
      }else if(counts > 6 && document.querySelector('.hs-container-stacked.hs-recommend-products') && document.querySelector('.hs-container-stacked.hs-recommend-products').style.display === 'none'){
        clearInterval(search_item);
        add_variants_to_upsell();
      }else if (counts > 10){
        clearInterval(search_item);
      }
      counts++;
    } , 200);
}

function attach_btn_to_listener(){
  // get all the ADD buttons from the suggesstion  
  let btns = document.querySelectorAll('.hs-upsell-add-to-cart.btn.hs-event-static');
  for(let x=0; x<btns.length; x++){
    btns[x].addEventListener('click', function(){
      let count = 0;
      // adding Listener to again attach listeners to all buttons on pressing add
      var wait_for_item_added = setInterval(() => {
        if (btns.length > document.querySelectorAll('.hs-upsell-add-to-cart.btn.hs-event-static').length){
          clearInterval(wait_for_item_added); 
          free_shipping();
          remove_items_fromCart_listener();
        }else if( count > 8 && btns.length == document.querySelectorAll('.hs-upsell-add-to-cart.btn.hs-event-static').length || count > 15){
          clearInterval(wait_for_item_added); 
          free_shipping();
          remove_items_fromCart_listener();
        }
        count++;
      },200);
    });
  }
}

function remove_discounts_from_cart(){
  let total_price = document.querySelectorAll('.hs-price-total');
  let discount_price = document.querySelectorAll('.hs-discount-price-total');
  let promo = document.querySelectorAll('.hs-discount-promo'); 
  for (let index = 0; index < total_price.length; index++) {
    total_price[index].classList.remove('hs-discount-price-line-through');
    try {
      discount_price[index].innerHTML = '';
    } catch (error) { }
    try {
      promo[index].innerHTML = '';
    } catch (error) { }
  }
  let subtotal_discount = document.querySelector('.hs_subtotal_amount_discount');
  let subtotal = document.querySelector('.hs_subtotal_amount');
  if (subtotal_discount.hasChildNodes()) {
    subtotal_discount.innerHTML = '';
  }
  subtotal.children[0].style.textDecoration = 'none';
  count_for_reccurssion = count_for_reccurssion + 1;
  if (promo.length !== 0 || count_for_reccurssion < 10) {
    setTimeout( ()=>{ remove_discounts_from_cart(); } , 500 );
  }
}

function free_shipping(){
  count_for_reccurssion = 0;
  jQuery.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(data) {
      // The item was added to the cart successfully
      console.log(data.items);
      for (let index = 0; index < data.items.length; index++) {
        console.log(data.items[index]);
        if (myArray.includes(data.items[index].product_type)) {
          try {
            document.querySelector('.hs-text-free-shipping').innerHTML = 'Congrats! You have unlocked free shipping!';
            document.getElementById("hs_shipping_bar").style.width = '100%';
          } catch (error) { }
        }
      }
      remove_discounts_from_cart();
    },
    error: function(XMLHttpRequest, textStatus) {
      // There was an error adding the item to the cart
      console.log(textStatus);
    }
  });
  // getting the title of products added in the cart
  let prd_descp = document.querySelectorAll('.hs-product-title');
  let variant = document.querySelectorAll('.hs-variant-title');
  for(let x = 0; x < prd_descp.length; x++){
    // if any product contain Subscription in its title 
    if(prd_descp[x].text.includes("Subscription") || variant[x].textContent.includes("Free Shipping")){
      // change the text and css of FREE shipping bar
      try {
            document.querySelector('.hs-text-free-shipping').innerHTML = 'Congrats! You have unlocked free shipping!';
            document.getElementById("hs_shipping_bar").style.width = '100%';
          } catch (error) { }
    }
  }
}

// adding listener to the clear all button showing in the cart
function clear_all_btn_listener(){
  let clear_button = document.querySelector('.hs-clear-all-button.hs-event-static');
  // if clear all button is loaded in the cart
  if(clear_button !== null){
      clear_button.addEventListener('click', function(){
      let count = 0;
        // when clear all btn is pressed then wait until the items are removed from the cart. 
      var wait_for_cart_empty = setInterval(() =>{
        if (document.querySelector('.hs-products-dynamic-stacked') && document.querySelector('.hs-products-dynamic-stacked').children.length > 1 || count > 15) {
          clearInterval(wait_for_cart_empty);
          // after removing itemsagain register the listeners
          remove_items_fromCart_listener();
        }
        count++;
      },100);
    });
    // else (clear all btn is not loaded wait until it is loaded)
  }else{
    let count = 0;
    var wait_for_btn = setInterval(() => {
      if(document.querySelector('.hs-clear-all-button.hs-event-static')){
        clearInterval(wait_for_btn);
        clear_all_btn_listener();
      } else if(document.querySelector('.hs-empty-cart')){
        clearInterval(wait_for_btn);
        count = 0;
        var wait_recommendation = setInterval(() => {
          if (document.querySelector('.hs-products-dynamic-stacked') && document.querySelector('.hs-products-dynamic-stacked').children.length > 1 && document.querySelector('.hs-count-products-cart') === null) {
            clearInterval(wait_recommendation);
            // after removing items again register the listeners
            attach_btn_to_listener();
            add_variants_to_upsell();
          }else if(count > 15){
            clearInterval(wait_recommendation);
          }
          count++;
        },100);
      } else if(count > 15) {
        clearInterval(wait_for_btn);
      }
      count ++;
    },100);
  }
}


function add_variants_to_upsell(){
  //get title of all the products in upsell showing
  let title = document.querySelectorAll('.hs-title-swiper');
  // iterating the loop through the entire title and appending variants after that.
  for (let x = 0; x < title.length; x++ ){
    let variant = document.createElement("h5");
    variant.innerHTML = document.querySelectorAll('.hs-swipper-select-option-add-to-cart.hs-hidden-element.hs-event-static')[x].textContent;
    variant.style.border = 'none';
    variant.style.background = 'transparent';
    variant.style.color = 'black';
    variant.style.margin = '0px';
    variant.style.width = '100%';
    variant.style.fontSize = '14px';
    variant.style.fontFamily = 'inherit';
    if (document.querySelectorAll('.hs-popup')[x].children.length == 2){
      title[x].after(variant);
      title[x].style.marginBottom = '2px';
    } 
  }
}